import React, { ReactElement } from 'react';
import { InsetText, Text } from 'idsk-react-components';
import LegislativnyMaterialDetail from '../../../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import { StadiumMaterialuEnum } from '../../../../../model/legislativnyMaterial/StadiumMaterialu';
import mapDate from '../../../../../function/mapDate';
import './legMaterialDetailMessage.scss';
import errorIcon from '../../../../../../assets/images/icon-error-red.svg';

interface Props {
  legMaterial: LegislativnyMaterialDetail;
}

const LegMaterialPripomienkovanieMessage = ({ legMaterial }: Props): ReactElement => {
  if ((legMaterial.stadium.hodnota === StadiumMaterialuEnum.PRIPRAVA_MATERIALU
      || legMaterial.stadium.hodnota === StadiumMaterialuEnum.ZAPIS_STANOVISKA
      || legMaterial.stadium.hodnota === StadiumMaterialuEnum.ZAPIS_PREDBEZNEHO_STANOVISKA
      || legMaterial.stadium.hodnota === StadiumMaterialuEnum.ZAPIS_DOPLNENEHO_PREDBEZNEHO_STANOVISKA)
    && legMaterial.datumZaciatkuPkMpk !== null
    && legMaterial.datumUkonceniaPkMpk !== null
    && legMaterial.datumZaciatkuPkMpk > new Date()) {
    return (
      <div className="material-detail-message-container">
        <InsetText id="mpkInFutureWarning" type="warn" className="span-red__inset-text" icon={errorIcon}>
          {legMaterial.typ.kod === 'PredbeznaInfo'
            ? (
              <Text type="span" bold>Štádium Vyjadrenia k predbežnej informácii bolo už nakonfigurované. Bude
                automaticky spustené {mapDate(legMaterial.datumZaciatkuPkMpk)} a
                ukončené {mapDate(legMaterial.datumUkonceniaPkMpk)}.
              </Text>
            )
            : (
              <Text type="span" bold>Štádium Pripomienkové konanie bolo už nakonfigurované. Bude
                automaticky spustené {mapDate(legMaterial.datumZaciatkuPkMpk)} a
                ukončené {mapDate(legMaterial.datumUkonceniaPkMpk)}.
              </Text>
            )}
        </InsetText>
      </div>
    );
  }

  return null;
};

export default LegMaterialPripomienkovanieMessage;
